// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__FacuN","loading":"skeleton_loading__nl1YN"};